import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { CHECKOUT_URL } from "@/lib/site";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="py-24 md:py-32 bg-slate-950">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[3rem] bg-slate-900 px-8 py-20 md:py-28 text-center shadow-[0_30px_60px_rgb(15,23,42,0.3)]">
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-blue-600/20 blur-3xl" aria-hidden="true" />
          <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-orange-600/20 blur-3xl" aria-hidden="true" />
          <div className="relative">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-tight max-w-3xl mx-auto">
              Your future self is 7 days away. <span className="text-blue-400">For free.</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-xl mx-auto leading-relaxed">
              Press play on day one tonight. If you don't feel the difference in a week, cancel and pay nothing.
            </p>
            <a data-testid="final-cta-button" href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer"
              className="mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 text-white px-10 py-5 text-lg font-bold transition-[transform,box-shadow] duration-300 shadow-[0_8px_20px_0_rgb(37,99,235,0.4)] hover:shadow-[0_12px_30px_0_rgb(37,99,235,0.5)] hover:-translate-y-1 active:translate-y-0 focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:outline-none focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900">
              Start Your 7-Day Free Trial <ArrowRight size={20} />
            </a>
            <p className="mt-5 text-sm text-slate-400 font-medium">No charge today · Cancel anytime in one tap</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
